import React, { useState, useEffect, useRef } from 'react'
import BackNavbar from '../../../../ReusableBlocks/Navbar';

import TeamReportsCarousel from './TeamReportsCarousel ';
import LoadingScreen from '../../../../ReusableBlocks/LoadingScreen';
import Swal from 'sweetalert2';
import BarChartHalf from "./BarChartHalf";
import LineChartHalf from "./LineChartHalf";
import StackkedBarChart from './StackedBarChartWithScroll'
import LineChartFull from './LineChartFull'
import LearningHubImage from '../../../../Images/learning_hub.png'

import { useDispatch, useSelector } from 'react-redux';
import { fetchManAnalyticsFuc } from '../../../../Redux/Dashboard/External/Analytics/MangerAnalytics/Action/ManAnalyticAction';
import { fetchAnalyticsFilterAct } from "../../../../Redux/Dashboard/External/Analytics/Filter/GetAnalyticsFilterAction";
import { motion, AnimatePresence } from "framer-motion";
import { FaRegCalendarAlt } from 'react-icons/fa';
import DemoLineChart from './DemoLineChart'
import LearningHubChart from './StackedBarChartLearning'
import { IMPACT_CONSOLE_TABS } from '../SalesImpactAnalytics/impactConsoleTabs';
import '../../../../Styles/LeadershipConsole.css';

const MANAGER_TABS = [
  { id: 'team', label: 'Team Analytics' },
  ...IMPACT_CONSOLE_TABS.map(({ id, label }) => ({ id, label })),
];




const ManagerConsole = () => {

  const dispatch = useDispatch();

  // Redux state selectors
  const currentUser = useSelector((state) => state.auth?.currentUser);
  const visibleTabs = MANAGER_TABS.filter((tab) => {
    const impactTab = IMPACT_CONSOLE_TABS.find((item) => item.id === tab.id);
    if (impactTab) {
      return impactTab.canAccessManager(currentUser);
    }
    return true;
  });
  const isLoading = useSelector((state) => state.MangerAnalytics?.loading);
  const errorMessage = useSelector((state) => state.MangerAnalytics?.error);
  const [selectedRange, setSelectedRange] = useState('Week');
  const [selectedRangeDisplay, setSelectedRangeDisplay] = useState('Quarter');
  const result = useSelector((state) => state.MangerAnalytics?.result[selectedRange]); // Get data for the current range
  const { filters, loading, error } = useSelector((state) => state.GetAnalyticsFilter); // Fetch from Redux
  const [showFilter, setShowFilter] = useState(false);

  console.log('Redux Result:', result);

  // State for selected range
  const [cachedData, setCachedData] = useState({
    Week: null,
    Month: null,
    Quarter: null,
    Year: null,
    LastWeek: null,
    LastMonth: null,
    LastQuarter: null,
    LastYear: null,
  });
  const [chartData, setChartData] = useState({
    narrativeBreakdown: { xData: [], yData: [] },
    demosRanByTeam: { xData: [], yData: [] },
    demosPerSE: [],
    bookingsPerSE: { xData: [], yData: [], details: [] },
  });
  const [keyPerformanceIndicators, setKeyPerformanceIndicators] = useState(null);
  const [teamLearningStatus, setTeamLearningStatus] = useState([]);
  const [teamsLearningCompletion, setTeamsLearningCompletion] = useState([]);
  const [activeTab, setActiveTab] = useState('team');
  const [containerClass, setContainerClass] = useState('container');

  useEffect(() => {
    const handleResize = () => {
      setContainerClass(window.innerWidth < 992 ? 'container-fluid' : 'container');
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const activeImpactTab = IMPACT_CONSOLE_TABS.find((tab) => tab.id === activeTab);
    if (activeImpactTab && !activeImpactTab.canAccessManager(currentUser)) {
      setActiveTab('team');
    }
  }, [activeTab, currentUser]);

  // Fetch data for Week by default on page load
  useEffect(() => {
    console.log('Fetching default Week data');
    dispatch(fetchManAnalyticsFuc('Week'));
  }, [dispatch]);



  // Fetch filters when component mounts
  useEffect(() => {
    dispatch(fetchAnalyticsFilterAct());
  }, [dispatch]);



  // Fetching Error 
  useEffect(() => {
    if (errorMessage && errorMessage !== 'You have not completed mandatory Tech Central Training, please complete it.') {
      Swal.fire({
        title: 'Error',
        text: errorMessage,
        icon: 'error',
        confirmButtonText: 'Retry',
        showCancelButton: true,
        customClass: {
          title: 'my-custom-title-of-pop-login',
          confirmButton: 'my-custom-button-of-pop',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
    }
  }, [errorMessage]);

  // Log cached data
  console.log('Cached Data:', cachedData);

  // Transformations
  const transformNarrativeBreakdown = (rawData) => {
    console.log('Transforming Narrative Breakdown:', rawData);
    return {
      xData: rawData?.map((item) => item.Narrative),
      yData: rawData?.map((item) => item.Count),
    };
  };

  const transformDemosRanByTeam = (rawData, range) => {
    console.log(`Transforming Demos Ran by Team (${range}):`, rawData);
    if (range === 'Week' || range === 'Month' || range === 'LastWeek' || range === 'LastMonth') {
      return {
        xData: rawData?.map((item) => item.Day),
        yData: rawData?.map((item) => item.Count),
      };
    } else if (range === 'Year' || range === 'LastYear') {
      return {
        xData: rawData?.map((item) => item.Month),
        yData: rawData?.map((item) => item.Count),
      };
    } else if (range === 'Quarter' || range === 'LastQuarter') {
      return {
        xData: rawData?.map((item) => item.Week),
        yData: rawData?.map((item) => item.Count),
      };
    }
    return { xData: [], yData: [] };
  };

  const transformDemosPerSE = (rawData) => {
    console.log("Raw Data for Demos Per SE:", rawData);

    // Check if rawData is a valid object
    if (typeof rawData !== "object" || rawData === null) {
      console.error("Invalid data for transformDemosPerSE:", rawData);
      return [];
    }

    // Transform data into the required structure
    return Object.entries(rawData).map(([name, breakdown]) => {
      if (!Array.isArray(breakdown)) {
        console.warn(`Invalid breakdown format for ${name}:`, breakdown);
        return { name };
      }

      // Filter out "totalCount" and transform the remaining data
      return {
        name,
        ...Object.fromEntries(
          breakdown
            .filter((item) => item.Narrative) // Exclude entries without "Narrative"
            .map((item) => [item.Narrative, item.Count])
        ),
      };
    });
  };



  const transformBookingsPerSE = (rawData, range) => {
    console.log(`Transforming Bookings Per SE (${range}):`, rawData);

    if (!Array.isArray(rawData)) {
      console.error("Invalid data for bookings per SE:", rawData);
      return {
        xData: [],
        yData: [],
        details: [],
      };
    }

    return {
      xData: rawData.map((item) =>
        range === "Quarter" || range === "LastQuarter"
          ? item.Week
          : range === "Week" || range === "LastWeek"
            ? item.Day
            : String(item.Day || item.Month)
      ),
      yData: rawData.map((item) => item.Count),
      details: rawData.map((item) => item.Breakdown || {}),
    };
  };



  // Update Key Performance Indicators
  const updateKeyPerformanceIndicators = (data) => {
    console.log('Updating Key Performance Indicators:', data);
    setKeyPerformanceIndicators(data['Key Performance Indicators']);
  };

  // Update Team Learning Status
  const updateTeamLearningStatus = (data) => {
    console.log("Updating Team's Learning Status:", data["Team's Learning Status"]);
    setTeamLearningStatus(data["Team's Learning Status"]);
  };


  // Update Team Learning completuion
  const updateTeamLearningCompletion = (data) => {
    console.log("Updating Team's Learning Status:", data["Team's Learning Completion"]);
    setTeamsLearningCompletion(data["Team's Learning Completion"]);
  };

  // Handle Range Change
  const handleRangeChange = (range) => {
    console.log('Range changed to:', range.value);
    setSelectedRange(range.value);
    setSelectedNew(range);
    setIsOpenNew(false);
    setSelectedRangeDisplay(range.display);
    setShowFilter(false);
    if (cachedData[range.value]) {
      console.log('Using cached data for range:', range.value);
      const data = cachedData[range.value];
      updateCharts(data, range.value);
      updateKeyPerformanceIndicators(data);
      updateTeamLearningStatus(data);
    } else {
      console.log('Fetching new data for range:', range.value);
      dispatch(fetchManAnalyticsFuc(range.value));
    }
  };

  // Update charts
  const updateCharts = (data, range) => {
    console.log('Updating charts with data:', data, 'for range:', range);
    setChartData({
      narrativeBreakdown: transformNarrativeBreakdown(data["Team's Narrative Breakdown"] || []),
      demosRanByTeam: transformDemosRanByTeam(data["Total Demos Ran by Team"] || [], range),
      demosPerSE: transformDemosPerSE(data["Number of Demos Done Per SE with Narrative Breakdown"] || {}),
      bookingsPerSE: transformBookingsPerSE(data["Total Number of Bookings per SE"] || [], range),
    });
  };

  useEffect(() => {
    if (result) {
      console.log('Received API Result:', result); // Log raw API response

      setCachedData((prevCache) => {
        console.log('Previous Cache:', prevCache); // Log existing cache
        const updatedCache = {
          ...prevCache,
          [selectedRange]: result,
        };
        console.log('Updated Cache:', updatedCache); // Log updated cache
        return updatedCache;
      });

      updateCharts(result, selectedRange);
      updateKeyPerformanceIndicators(result);
      updateTeamLearningStatus(result);
      updateTeamLearningCompletion(result);
    }
  }, [result, selectedRange]);







  console.log(teamLearningStatus)

  const dummyApiResponse = [
    {
      "Vaibhav Shriramjwar": {
        "Tracks Completed": "3/3",
        "Microcerts Completed (%)": 26,
        "List of Microcerts": [
          { title: "Enterprise Visualization", trackTitle: "AIOps & ServiceOps", status: "Completed" },
          { title: "Dynamic Service Modeling", trackTitle: "AIOps & ServiceOps", status: "Completed" },
          { title: "Intelligent Integrations", trackTitle: "AIOps & ServiceOps", status: "Completed" },
          { title: "AI-ML Based Noise Reduction", trackTitle: "AIOps & ServiceOps", status: "In Progress" },
          { title: "ITSM Jira Integration", trackTitle: "ITSM & ESM", status: "Completed" },
          { title: "HRSM - Employee Offboarding", trackTitle: "ITSM & ESM", status: "In Progress" },
          { title: "Dashboard - Intro", trackTitle: "Platform Narratives", status: "Completed" },
          { title: "Dashboard - CSM", trackTitle: "Platform Narratives", status: "In Progress" },
        ],
      },
    },
    {
      "Emil Ng": {
        "Tracks Completed": "1/3",
        "Microcerts Completed (%)": 12,
        "List of Microcerts": [
          { title: "Enterprise Visualization", trackTitle: "AIOps & ServiceOps", status: "Completed" },
          { title: "AI-ML Based Noise Reduction", trackTitle: "AIOps & ServiceOps", status: "Not Completed" },
          { title: "ITSM Jira Integration", trackTitle: "ITSM & ESM", status: "In Progress" },
          { title: "Dashboard - HRSM", trackTitle: "Platform Narratives", status: "Not Completed" },
        ],
      },
    },
    {
      "Ravinder Kumar": {
        "Tracks Completed": "0/3",
        "Microcerts Completed (%)": 0,
        "List of Microcerts": [
          { title: "Dynamic Service Modeling", trackTitle: "AIOps & ServiceOps", status: "Not Completed" },
          { title: "HRSM - Employee Onboarding", trackTitle: "ITSM & ESM", status: "Not Completed" },
          { title: "Dashboard - Asset Management", trackTitle: "Platform Narratives", status: "Not Completed" },
        ],
      },
    },
  ];




  const formatRangeLabel = (range) => {
    const rangeMapping = {
      Week: 'Current Week (Feb 12 - Feb 18)',
      Month: 'Current Month (February)',
      Quarter: 'Current Quarter (Q1 2025)',
      Year: 'Current Year (FY 25)',
      LastWeek: 'Last Week (Feb 5 - Feb 11)',
      LastMonth: 'Last Month (January)',
      LastQuarter: 'Last Quarter (Q4 2024)',
      LastYear: 'Last Year (FY 24)',
    };
    return rangeMapping[range] || 'Select Range';
  };



  // Set default selection to the first item (Week) once filters are available
  useEffect(() => {
    if (filters.length > 0 && !selectedRange) {
      setSelectedRange(filters[0].value); // ✅ Default to the first filter
    }
  }, [filters, selectedRange, setSelectedRange]);



  const timeRanges = [
    { label: "Current Week", value: "current-week", date: "( Feb 17 - Feb 21 )" },
    { label: "Last Week", value: "last-week", date: "( Feb 10 - Feb 14 )" },
    { label: "Current Month", value: "current-month", date: "( February )" },
    { label: "Last Month", value: "last-month", date: "( January )" },
    { label: "Current Quarter", value: "current-quarter", date: "( Q3 FY25 )" },
    { label: "Last Quarter", value: "last-quarter", date: "( Q1 FY25 )" },
    { label: "Current Year", value: "current-year", date: "( FY 25 )" },
    { label: "Last Year", value: "last-year", date: "( FY 24 )" },
  ];

  const [selectedNew, setSelectedNew] = useState(timeRanges[0]);
  const [isOpenNew, setIsOpenNew] = useState(false);

  // Toggle dropdown
  const toggleDropdownNew = (e) => {
    e.stopPropagation();
    setIsOpenNew((prev) => !prev);
  };

  const handleSelectNew = (item) => {
    setSelectedNew(item);
    setIsOpenNew(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpenNew && !event.target.closest(".new-con-filter-dropdown-container")) {
        setIsOpenNew(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [isOpenNew]);





 

  return (
    <>
      {isLoading && activeTab === 'team' && <LoadingScreen text="Loading Analytics" />}
      <BackNavbar />

      <div className="manager-console-background lead-dash-page">


        {/* Hero Section */}
        <section>
          <div className="manager-console-hero-section">
            <div className="container">
              <div className="learning-hub-micro-certs-her-content">
                <h6 className="learning-hub-micro-certs-her-content-h1">Manager Console</h6>
              </div>
            </div>
          </div>
        </section>

        <div className={`${containerClass} leadership-analytics-container`}>
          <div className="lead-dash-tabs" role="tablist">
            {visibleTabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                role="tab"
                aria-selected={activeTab === tab.id}
                className={`lead-dash-tab ${activeTab === tab.id ? 'lead-dash-tab-active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {IMPACT_CONSOLE_TABS.map(({ id, Component, canAccessManager }) => (
            activeTab === id && canAccessManager(currentUser) ? <Component key={id} /> : null
          ))}

          {activeTab === 'team' && (
        <>
          {/* KPI Title with Orange Underline */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="manager-console-kpi-title-container">
              <h3 className="manager-console-kpi-title">Key Performance Indicators</h3>
              <div className="manager-console-kpi-underline"></div>
            </div>



            <div className="new-con-filter-dropdown-container" onMouseEnter={() => setIsOpenNew(true)}
              onMouseLeave={() => setIsOpenNew(false)}>
              <button className="new-con-filter-dropdown-button" onClick={toggleDropdownNew}>
                <FaRegCalendarAlt className="new-con-filter-dropdown-icon" />   {loading ? "Loading..." : filters.find((f) => f.value === selectedRange)?.label || filters[0]?.label}
                <span className="new-con-filter-dropdown-arrow">&#9662;</span>
              </button>

              {/* Show Error if API fails */}
              {error && <p className="error-message">{error}</p>}

              <AnimatePresence>
                {isOpenNew && filters.length > 0 && (
                  <motion.div className="new-con-filter-dropdown-menu"
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }} >
                    <div className="new-con-filter-dropdown-columns">
                      {/* Left Column: Current Periods */}
                      <div className="new-con-filter-dropdown-column">
                        {filters
                          .filter((item) => item.label.toLowerCase().includes("current"))
                          .map((item) => (
                            <div
                              key={item.value}
                              className={`new-con-filter-dropdown-item ${selectedRange === item.value ? "new-con-filter-selected" : ""}`}
                              // onClick={() => handleSelectNew(item)}
                              onClick={() => handleRangeChange(item)}
                            >
                              <h1 className='filter-text'>{item.label}</h1>
                              <span className="new-con-filter-dropdown-date">{item.display}</span>
                            </div>
                          ))}
                      </div>

                      {/* Right Column: Last Periods */}
                      <div className="new-con-filter-dropdown-column">
                        {filters
                          .filter((item) => item.value.toLowerCase().includes("last"))
                          .map((item) => (
                            <div
                              key={item.value}
                              className={`new-con-filter-dropdown-item ${selectedRange === item.value ? "new-con-filter-selected" : ""}`}
                              onClick={() => handleRangeChange(item)}
                            >
                              <h1 className='filter-text'>{item.label}</h1>
                              <span className="new-con-filter-dropdown-date">{item.display}</span>
                            </div>
                          ))}
                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>


            </div>
          </div>




          <div className="row gx-3 gy-4">
            {/* Global Average Demos */}
            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-12 col-12">
              <div className="manager-console-kpi-box manager-console-kpi-light">
                <h5>Global Average Demos Per SE</h5>
                <h2>{keyPerformanceIndicators?.["Global Average Demos Per SE"]}</h2>
                {keyPerformanceIndicators?.["Global Average Demos Per SE (% Increment/Decrement)"] > 0 ? (
                  <p style={{ color: 'green', display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '5px' }}>▲</span> {/* Up arrow */}
                    Up by {keyPerformanceIndicators?.["Global Average Demos Per SE (% Increment/Decrement)"]}% from last {selectedRange.replace(/^Last/, "")}
                  </p>
                ) : keyPerformanceIndicators?.["Global Average Demos Per SE (% Increment/Decrement)"] < 0 ? (
                  <p style={{ color: 'red', display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '5px' }}>▼</span> {/* Down arrow */}
                    Down by {Math.abs(keyPerformanceIndicators?.["Global Average Demos Per SE (% Increment/Decrement)"])}% from last {selectedRange.replace(/^Last/, "")}
                  </p>
                ) : (
                  <p style={{ color: 'gray', display: 'flex', alignItems: 'center' }}>
                    No change from last {selectedRange.replace(/^Last/, "")}
                  </p>
                )}
              </div>
            </div>


            {/* Average Demos Per SE In Your Team */}
            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-12 col-12">
              <div className="manager-console-kpi-box manager-console-kpi-light">
                <h5>Average Demos Per SE In Your Team</h5>
                <h2>{keyPerformanceIndicators?.["Team's Average Demos Per SE"]}</h2>
                {keyPerformanceIndicators?.["Team's Average Demos Per SE (% Increment/Decrement)"] > 0 ? (
                  <p style={{ color: 'green', display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '5px' }}>▲</span> {/* Up arrow */}
                    Up by {keyPerformanceIndicators?.["Team's Average Demos Per SE (% Increment/Decrement)"]}% from last {selectedRange.replace(/^Last/, "")}
                  </p>
                ) : keyPerformanceIndicators?.["Team's Average Demos Per SE (% Increment/Decrement)"] < 0 ? (
                  <p style={{ color: 'red', display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '5px' }}>▼</span> {/* Down arrow */}
                    Down by {Math.abs(keyPerformanceIndicators?.["Team's Average Demos Per SE (% Increment/Decrement)"])}% from last {selectedRange.replace(/^Last/, "")}
                  </p>
                ) : (
                  <p style={{ color: 'gray', display: 'flex', alignItems: 'center' }}>
                    No change from last {selectedRange.replace(/^Last/, "")}
                  </p>)}
              </div>
            </div>


            {/* Top 3 Narratives Globally */}
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="manager-console-kpi-box manager-console-kpi-pink">
                <h5>Top 3 Narratives Globally</h5>
                <ul className="manager-console-narratives-list">
                  {keyPerformanceIndicators?.["Top 3 Narratives Globally"]?.length === 0 ? (
                    <li className="no-data">Data not available for the {selectedRange}</li>
                  ) : (
                    keyPerformanceIndicators?.["Top 3 Narratives Globally"]?.map(([narrative, score], index) => (
                      <li key={index}>
                        <a href="#">
                          {narrative}
                          <span className="underline"></span>
                        </a>
                      </li>
                    ))
                  )}
                </ul>
              </div>
            </div>

            {/* Team's Top 3 Narratives */}
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="manager-console-kpi-box manager-console-kpi-pink">
                <h5>Team's Top 3 Narratives</h5>
                <ul className="manager-console-narratives-list">
                  {keyPerformanceIndicators?.["Team's Top 3 Narratives"]?.length === 0 ? (
                    <li className="no-data">Data not available for the selected range</li>
                  ) : (
                    keyPerformanceIndicators?.["Team's Top 3 Narratives"]?.map(([narrative, score], index) => (
                      <li key={index}>
                        <a href="#">
                          {narrative}
                          <span className="underline"></span>
                        </a>
                      </li>
                    ))
                  )}
                </ul>
              </div>
            </div>


            {/* Team Training Completion */}
            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-12 col-12">
              <div className="manager-console-kpi-box manager-console-kpi-purple">
                <h5>LearningHub Completion (Ninja) %</h5>
                <h2>{keyPerformanceIndicators?.["Team's 100% Learning Completion (%)"]}%</h2>
                {keyPerformanceIndicators?.["Team's 100% Learning Completion (% Increment/Decrement)"] > 0 ? (
                  <p style={{ color: 'green', display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '5px' }}>▲</span> {/* Up arrow */}
                    Up by {keyPerformanceIndicators?.["Team's 100% Learning Completion (% Increment/Decrement)"]}% from last {selectedRange.replace(/^Last/, "")}
                  </p>
                ) : keyPerformanceIndicators?.["Team's 100% Learning Completion (% Increment/Decrement)"] < 0 ? (
                  <p style={{ color: 'red', display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '5px' }}>▼</span> {/* Down arrow */}
                    Down by {Math.abs(keyPerformanceIndicators?.["Team's 100% Learning Completion (% Increment/Decrement)"])}% from last {selectedRange.replace(/^Last/, "")}
                  </p>
                ) : (
                  <p style={{ color: 'gray', display: 'flex', alignItems: 'center' }}>
                    No change from last {selectedRange.replace(/^Last/, "")}
                  </p>
                )}
              </div>
            </div>

          </div>








          <br></br>
          <div className="row gx-4">

            {/* Bar Chart Section */}
            <div className="col-md-6">
              <div className="manager-console-chart-box">
                <div className="manager-console-chart-header">
                  <h5 className="manager-console-chart-title">Top Narratives in Your Team </h5>
                </div>
                <BarChartHalf data={chartData.narrativeBreakdown} />
              </div>
            </div>

            {/* Line Chart Section */}
            <div className="col-md-6">
              <div className="manager-console-chart-box">
                <div className="manager-console-chart-header">
                  <h5 className="manager-console-chart-title">Demo Volumes & Trends</h5>
                </div>
                <LineChartHalf data={chartData.demosRanByTeam} range={selectedRange} display={selectedRangeDisplay} />
              </div>
            </div>

          </div>



          <br></br>
          <div className="manager-console-chart-container">
            <div className="manager-console-chart-header">
              <h5 className="manager-console-chart-title">Individual SE Demo Count Breakdown</h5>

            </div>
            <div className="manager-console-chart-scroll">
              <StackkedBarChart data={chartData.demosPerSE} />
            </div>
          </div>



          <br></br>


          <div className="manager-console-chart-container">
            <div className="manager-console-chart-header">
              <h5 className="manager-console-chart-title">Booking Volumes Per SE</h5>
            </div>
            <div className="manager-console-chart-scroll">
              <LineChartFull data={chartData.bookingsPerSE} range={selectedRange} display={selectedRangeDisplay} />
            </div>
          </div>



          <br></br>
          <br></br>

          <img src={LearningHubImage} />
          <br></br><br></br>
          <div className="manager-console-chart-container">

            <div className="manager-console-chart-scroll">
              <LearningHubChart data={teamsLearningCompletion} />
            </div>
          </div>



          <br></br><br></br>
          {teamLearningStatus ? (
            <TeamReportsCarousel teamLearningStatus={teamLearningStatus} />
          ) : (
            <p>Loading...</p>
          )}
          <br></br>

        </>
          )}
        </div>


        {/* <DemoLineChart />
        <LearningHubChart data={teamLearningStatus} /> */}

        <br></br><br></br>

      </div>


    </>
  )
}

export default ManagerConsole